<template>
	<component
		class="radio-group"
		:options="swiperOption"
		:is="componentType"
		:class="{'radio-group--grid': type != 'swiper'}"
	>
		<component
			class="radio-group__component"
			v-for="(item, i) in formattedDate"
			:key="i"
			:is="type == 'swiper' ? 'swiper-slide' : 'div'"
		>
			<input
				name="radio__input"
				type="radio"
				ref="input"
				@click="switchDay($event, i)"
				:checked="dateArray[i] == currentDay"
				:id="`radio__input-${name}-${i}`"
			>
			<label
				class="radio__input-label"
				:for="`radio__input-${name}-${i}`"
			>
				{{ item }}
			</label>
		</component>
	</component>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { mapGetters } from 'vuex';

export default {
	components: { Swiper, SwiperSlide },

	props: ['dateArray', 'name', 'type'],

	data() {
		return {
			currentDay: this.$cookie.get('day'),
		}
	},

	computed: {
		...mapGetters({
      currentBasket: "getCurrentBasket",
      cartCount: "getCartProductsCount",
		}),

		componentType() {
			return this.type == 'swiper' ? 'swiper' : 'div';
		},
	
		swiperOption() {
			return {
				slidesPerView: 'auto',
				freeMode: true,
				spaceBetween: 8,
			}
		},

		formattedDate() {
			const formatter = new Intl.DateTimeFormat('ru-RU', {
			  weekday: 'short',
			  day: 'numeric',
			  month: 'long',
			});

			return this.dateArray.map(el => {
				const date			= new Date(el);
				const today			= new Date().getDate();
				const tomorrow	= today + 1;

				if (date.getDate() == today)
					return 'Заказ на сегодня'
				else if (date.getDate() == tomorrow)
					return 'Заказ на завтра'
				else
					return formatter.format(date).charAt(0).toUpperCase() + formatter.format(date).slice(1);
			})
		},
	},

	methods: {
		switchDay(event, idx) {
			if (this.cartCount || this.currentBasket?.collective)
				event.preventDefault();

			this.$emit('switchDay', { day: this.dateArray[idx], idx })
		}
	},

	mounted() {
		window.addEventListener('cookie-changed', () => {
			this.currentDay = this.$cookie.get('day');
		})
	},
}
</script>

<style lang='scss'>
.radio-group {
	width: 100%;
	max-width: 100%;
	margin-top: 32px;
	overflow: hidden;

	&.unactive {
		.swiper-wrapper {
			opacity: .6;
			pointer-events: none;
		}
	}

	&--grid {
		display: flex;
		gap: 8px;
		flex-wrap: wrap;
    font-family: 'Roboto';
	}

	.swiper-wrapper { display: flex }

	.swiper-slide {
		width: auto;
		flex: 0 0 auto;
	}

	input { display: none }

	label {
		display: block;
		user-select: none;
		padding: 12px 16px;
		border-radius: 16px;
		background-color: #F2F4F7;
		color: $textColor;
		transition: .2s ease-in-out;

		@media (max-width: 567px) {
			padding: 10px 12px;
			font-size: 14px;
		}
	}

	input:checked+label {
		background-color: #2D2F32;
		color: #FFF;
	}

	@media (max-width: 520px) { overflow: visible }
}
</style>